import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { getVersion, postVersion, versionDelete } from "./VersionService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import moment from "moment";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

const Version = () => {
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [versionLists, setVersionList] = useState([]);
  const toster = useContext(TostMsg);
  const [loading, setLoading] = useState(false);
  const [versionDeleteId, setVersionDeleteId] = useState(0);
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  const [userDeletePermission, setUserDeletePermission] = useState(false);
  const [openSections, setOpenSections] = useState({});
  const [systemAlertList, setSystemAlertList] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const sections = [{ id: 1 }];
  const history = useHistory();

  useEffect(() => {
    GetMasterSystemAlertList('version_value', 1)
    GetVersion();
    permissionArticleAdd();
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSystemAlertList(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const permissionArticleAdd = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Version.Delete") {
        setUserDeletePermission(true);
      } else if (UserPermission.PermissionName == "Version.Create") {
        setUserUpdatePermission(true);
      }
    });
  };

  const GetVersion = async () => {
    setLoading(true);
    try {
      let res = await getVersion();
      let Data = res?.Data?.filter((el) => el?.Type === 'Mobile');
      setVersionList(Data);
      localStorage.setItem("AppVersion", JSON.stringify(res?.Data?.find((el) => el?.Type == "Mobile")));
      setLoading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.VersionError);
      setLoading(false);
    }
  };

  const toggleSection = (itemId, sectionId) => {
    setOpenSections((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [sectionId]: !prev[itemId]?.[sectionId],
      },
    }));
  };

  const VersionDelete = async () => {
    setLoading(true);
    if (versionDeleteId) {
      let params = {
        id: versionDeleteId,
      };
      try {
        await versionDelete(params);
        setLoading(false);
        GetVersion();
        document.getElementById("delete-ed").click();
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.VersionError);
      }
    }
  };

  const editVersionId = async (value) => {
    history.push(`/EditVersion/${value}`);
  };

  return (
    <>
      <div className="container-fluid   position-relation">
        <div className="row justify-content-center pt-4">
          <div className="col-md-11">
            <div className="form-head display-grid align-items-center ">
              <div className="me-auto">
                <h2 className="version-h2 mb-2">Version</h2>
                <p className="version-des">
                 {systemAlertList}
                </p>
              </div>
              {userUpdatePermission && <div className="rightside-tabs mb-0">
                <Link to="/Upgrade">
                  <button className="savebutton">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Version
                  </button>
                </Link>
              </div>}
            </div>
          </div>
          <div className="col-md-11">
            <div className="about-orggenie about-version">
              <div className="row" style={{ rowGap: "20px" }}>
                {versionLists?.map((versionList) => (
                  <div className="col-md-12" key={versionList.Id}>
                    {sections?.map((section, index) => (
                      <div className="accordian-content" key={section?.Id}>
                        <div className="acc-head">
                          <img
                            className="avatar"
                            src="images/icon2.png"
                            alt=""
                          />
                          <div className="detail-acc">
                            <h3>Version: {versionList?.NewVersion}</h3>
                            <p>
                              Release Date :{" "}
                              {moment(versionList?.CreatedDate)?.format(
                                "Do MMMM YYYY"
                              )}
                            </p>
                          </div>
                          <div className="actions-click">
                            {userUpdatePermission && <span
                              className="delete"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-toggle="modal"
                              title="Edit"
                              onClick={() => editVersionId(versionList?.GUID)}
                              data-bs-original-title="delete"
                              aria-label="delete"
                            >
                              <img src="/images/tickets/edit-ico.svg" className="" title="Edit" />
                            </span>}
                            {userDeletePermission && <span
                              className="delete"
                              data-toggle="tooltip"
                              data-placement="top"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-ed"
                              title="Delete"
                              onClick={() => setVersionDeleteId(versionList?.Id)}
                              data-bs-original-title="delete"
                              aria-label="delete"
                            >
                              <img src="/images/tickets/delete.svg" className="" title="Delete" />
                            </span>}
                          </div>
                          <div
                            onClick={() => toggleSection(versionList.Id, section.Id)}
                          >
                            {openSections[versionList.Id]?.[section.Id] ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                ></path>
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                ></path>
                              </svg>
                            )}
                          </div>
                        </div>
                        {openSections[versionList?.Id]?.[section?.Id] && (
                          <div className="acc-detailed">
                            <div className="action-btns"></div>
                            <p>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: versionList?.VersionDetails,
                                }}
                              />
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                 ))} 
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="delete-ed">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                <p>Do you really want to delete this version?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => VersionDelete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default Version;
